<template>
    <div>
        <div class="actions">
            <button class="btn btn-primary" data-toggle="modal" :data-target="'#modal-new'">Pievienot jaunu aktu</button>
        </div>
        <div class="modal fade" tabindex="-1"  :id="'modal-new'" ref="vuemodal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-white">
                        <h5 class="modal-title">Jauna akta pievienošana</h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="modalMenu">

                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="act_number">Akta numurs</label>
                                    <input type="text" name="act_number" id="act_number" v-model="act_number" class="form-control" :class="{'is-invalid':errors && ( 'act_number' in errors)}" autocomplete="off">
                                    <small class="text-danger" v-if="errors && errors.act_number">{{errors.act_number[0]}}</small>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group text-right">
                                    <input type="button" v-if="loading == false" class="btn btn-primary" value="Pievienot" @click="create()">
                                    <button type="button" v-else class="btn btn-primary"  v-if="loading == true"><i class="fas fa-spinner fa-spin"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <table class="table">
            <thead class="bg-primary text-white">
                <tr>
                    <th>Numurs</th>
                    <th>Datums</th>
                    <th>Otra puse</th>
                    <th>Termiņš</th>
                    <th>Priekšmetu skaits</th>
                    <th>Darbības</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="act in acts" :key="act.id">
                    <td>{{act.act_number}}</td>
                    <td>{{normalDate(act.act_date)}}</td>
                    <td>
                        <span v-if="act.act_giver_type == 'legal_person'">
                         {{act.act_giver_firstname}} {{act.act_giver_lastname}}, {{act.act_giver_position}}, {{act.act_giver_institution_name}}
                    </span>
                        <span v-if="act.act_giver_type == 'individual'">
                        {{act.act_giver_firstname}} {{act.act_giver_lastname}}
                    </span>
                    </td>
                    <td>{{normalDate(act.act_due_date)}}</td>
                    <td>{{act.items_count}}</td>
                    <td class="actions">
                        <a :href="'/temp-acts/show/'+act.id"><span class="material-icons">edit</span></a>
                        <div @click=deleteAct(act.id) class="delete"><span class="material-icons">close</span></div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default{
    mounted()
    {
        this.getActs();
        var that = this;
        EventBus.$on('act_deleted', acts =>{
            that.acts = acts;
        })
    },
    methods:{
        normalDate(date)
        {
            if(date != null) {
                return moment(date).format('DD.MM.YYYY.')
            }
            else
            {
                return null;
            }
        },
      getActs()
      {
          var that = this;
          axios.post('/temp-acts/get-acts').then(response =>{
             if(response.data.status == 'ok')
             {
                 that.acts = response.data.acts;
             }
          });
      },
        deleteAct(act_id)
        {
            var that = this;
            that.$swal.fire({
                title: 'Vai tiešām vēlaties dzēst aktu?',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#E53935',
                cancelButtonColor: '#888787',
                confirmButtonText: 'Dzēst',
                cancelButtonText: 'Atcelt'
            }).then((result) => {
                    if (result.value) {
                        axios.post('/temp-acts/delete/'+act_id)
                            .then(response =>{
                                if(response.data.status == 'ok')
                                {
                                    that.$toast.open(response.data.message);
                                    EventBus.$emit('act_deleted', response.data.acts);
                                }
                                if(response.data.status == 'error')
                                {
                                    that.$toast.error(response.data.message);
                                }
                        })
                    }});
        },

      create()
      {
        var that = this;
        axios.post('/temp-acts/create',{
            act_number: that.act_number
        }).then(response =>{
            if(response.data.status == 'ok')
            {
                that.loading = false;
                that.$toast.open(response.data.message);
                window.location.replace("/temp-acts/show/"+response.data.act.id);
            }
            else {
                that.errors = response.data.errors;
                that.$toast.error(response.data.message);
            }
        })

      }


    },

    data()
    {
        return{
            acts:[],
            errors:[],
            loading:false,
            act_number:"",
        }
    }
}
</script>

<style lang="scss" scoped>
.actions{
    display:flex;
    justify-content: flex-end;
    margin-bottom:20px;
}
</style>
